export default {
  contingent_retrocession: {
    list: {
      page_title: 'Liste des rétrocessions'
    },
    show: {
      page_title: 'Détails Rétrocession'
    }
  },
  hotel_retrocession: {
    list: {
      page_title: 'Liste des rétrocessions'
    },
    show: {
      page_title: 'Détails Rétrocession'
    }
  }
}
